'use client';

import { c as _c } from "react/compiler-runtime";
import { useWebHaptics } from 'web-haptics/react';
interface ViewToggleProps {
  viewMode: 'closet' | 'outfits' | 'create';
  onViewChange: (mode: 'closet' | 'outfits' | 'create') => void;
}
export function ViewToggle(t0) {
  const $ = _c(15);
  const {
    viewMode,
    onViewChange
  } = t0;
  const haptic = useWebHaptics();
  let t1;
  if ($[0] !== haptic || $[1] !== onViewChange) {
    t1 = () => {
      haptic.trigger("selection");
      onViewChange("outfits");
    };
    $[0] = haptic;
    $[1] = onViewChange;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = `text-sm transition-opacity ${viewMode === "outfits" ? "opacity-100" : "opacity-40 hover:opacity-60"}`;
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = <button type="button" onClick={t1} className={t2}>OUTFITS</button>;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== haptic || $[7] !== onViewChange) {
    t4 = () => {
      haptic.trigger("selection");
      onViewChange("closet");
    };
    $[6] = haptic;
    $[7] = onViewChange;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = `text-sm transition-opacity ${viewMode === "closet" ? "opacity-100" : "opacity-40 hover:opacity-60"}`;
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <button type="button" onClick={t4} className={t5}>CLOSET</button>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t3 || $[13] !== t6) {
    t7 = <div className="flex items-center gap-6">{t3}{t6}</div>;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}